import{get,post}    from    './index.js'

export  const   appGetArticleDetailApi  =  params   =>  get("/app/article",params)              //获取文章详情

export  const   appOpenOpenAppUrlApi    =   data    =>  post("/app/openOpenAppUrl",data)        //保存访问/openApp时的记录

export  const   appOpenHomePageApi      =   data    =>  post("/app/openHomePage",data)          //首页访问